import { t } from 'i18next';

import { InterviewStatus } from '@/services/api/codegen/api';

// eslint-disable-next-line complexity
export const statusLabel = (Value: string = '') => {
  switch (Value) {
    case InterviewStatus.Added:
      return t('interview:status.added');
    case InterviewStatus.Invited:
      return t('interview:status.invited');
    case InterviewStatus.NotCompleted:
      return t('interview:status.notCompleted');
    case InterviewStatus.Completed:
      return t('interview:status.completed');
    case InterviewStatus.Evaluated:
      return t('interview:status.evaluated');
    case InterviewStatus.Positive:
      return t('interview:status.positive');
    case InterviewStatus.Negative:
      return t('interview:status.negative');
    case InterviewStatus.Hired:
      return t('interview:status.hired');
    case InterviewStatus.Pending:
      return t('interview:status.pending');
    case InterviewStatus.ActionRequired:
      return t('interview:status.actionRequired');
    case InterviewStatus.Paused:
      return t('interview:status.paused');
    case InterviewStatus.Deleted:
      return t('interview:status.deleted');
    case InterviewStatus.InternalProcess:
      return t('interview:status.internalProcess');
    case InterviewStatus.InTheInterview:
      return t('interview:status.inTheInterview');
    case InterviewStatus.InternalProcessTwo:
      return t('interview:statuses.statusInternalProcessTwo');
    case InterviewStatus.NotInterested:
      return t('interview:statuses.statusNotInterested');
    case InterviewStatus.SentAgain:
      return t('interview:statuses.statusSentAgain');
    case InterviewStatus.PreliminaryCompleted:
      return t('interview:statuses.statusPreliminaryCompleted');
    case InterviewStatus.OfferSent:
      return t('interview:statuses.statusOfferSent');
    case InterviewStatus.OfferRejected:
      return t('interview:statuses.statusOfferRejected');
    case InterviewStatus.OfferAccepted:
      return t('interview:statuses.statusOfferAccepted');
    case InterviewStatus.ReferenceCheck:
      return t('interview:statuses.statusReferenceCheck');
    case InterviewStatus.Withdrawn:
      return t('interview:statuses.statusWithdrawn');
    case 'Active':
      return t('interview:status.active');
    case 'Inactive':
      return t('interview:status.inactive');

    default:
      return Value;
  }
};
